import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BannerImage from '../img/Caseta-Afir.png';

const SocialMediaLinks = () => {
  const { t } = useTranslation();
 
   return (
    <footer className="relative bg-gray-100 dark:bg-gray-800 py-0 overflow-hidden">
      <div className="container mx-auto px-4 py-2 space-y-2">
        <div className="text-center">
          <p className="text-gray-700 dark:text-gray-200 text-sm md:text-base">
            {t('home.bottomTagline')}
          </p>
        </div>
        <div className="relative w-full flex items-center justify-center">
          <img
            src={BannerImage}
            alt="Footer banner"
            className="h-8 md:h-10 lg:h-12 w-auto object-contain"
          />
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <Link
              to="/gdpr"
              className="text-gray-600 hover:text-primary dark:text-gray-300 dark:hover:text-primary whitespace-nowrap"
            >
              {t('footer.gdpr')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default SocialMediaLinks;
